// authSlice.js
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios';
import { jwtDecode } from 'jwt-decode'
import {toast} from 'react-hot-toast';
import {url} from '../services/api'



const initialState = {
    token: sessionStorage.getItem('token'),
    name: sessionStorage.getItem('name'),
    email: sessionStorage.getItem('email'),
    role: '',
    _id: '',
    category:sessionStorage.getItem('category'),
};

export const loginemployee = createAsyncThunk(
    "employee/loginemployee",
    async (employee) => {
        try {
            const res = await axios.post(`${url}/api/login`, {
                email: employee.email,
                password: employee.password,
                role:employee.role,
            });
            
            if (res.status===200) {
                toast.success("Login Successful");
                // console.log(res.data);
                sessionStorage.setItem('token', res.data.token);
                sessionStorage.setItem('category',res.data.productCategory);      
                sessionStorage.setItem('name',res.data.name);          
                sessionStorage.setItem('email',res.data.email); 
            }

            return res.data.token;
        } catch (error) {
            toast.error(`Error : ${error?.response?.data?.message}`)
        }
    }
)

const employeeSlice = createSlice({
    name: 'employee',
    initialState,
    reducers: {
        loademployee(state, action) {
            const token = state.token
           // const category = state.category;
            if (token) {
                const employee = jwtDecode(token);
                // console.log("token decode", employee);
                return {
                    ...state,
                    token,
                    //name: employee.name,
                    //email: employee.email,
                    _id: employee._id,
                    role: employee.role,
                   category:sessionStorage.getItem('category'),
                    
                };
            }
        },
        logoutemployee(state, action) {
            sessionStorage.removeItem('token');

            return {
                ...state,
                token: "",
                name: "",
                email: '',
                role: '',
                _id: '',
                category:null
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(loginemployee.fulfilled, (state, action) => {
            if (action.payload) {
                const employee = jwtDecode(action.payload);
                return {
                    ...state,
                    token: action.payload,
                   // name: employee.name,
                    //email: employee.email,
                    _id: employee._id,
                    role: employee.role,
                   category:sessionStorage.getItem('category'),
                }
            }
            else {
                return state
            }
        });
    }
});

export const { loademployee, logoutemployee } = employeeSlice.actions
export default employeeSlice.reducer